<template>
  <div class="vessel-labor-record-row flex hover-enabled">
    <template>
      <div class="date aisea-text-16-400-gray-black flex items-center z-30 g">
        <p class="link-string" @click="onClickRoleName">
          {{ roleName }}
        </p>
      </div>
      <!-- v-if="!isBeforeToday" -->
      <div
        class="
        working-graph
        flex
        items-center
        flex-shrink-0
        relative
        aisea-text-14-400-dark-gray
      "
      >
        <div class="timeline flex flex-shrink-0">
          <!-- 時間を超過したセルにアラート: 黄・赤 -->
          <div
            v-for="(n, i) of cellNum"
            :key="`timeline-${i}`"
            class="timeline-cell text-center"
          ></div>
        </div>
        <!-- 線の入った部分 -->
        <div class="divider-div z-20 absolute flex pointer-events-none h-full">
          <div
            v-for="(n, i) of cellNum"
            :key="`divider-${i}`"
            class="timeline-cell text-center items-center divider"
          ></div>
        </div>

        <!-- 作業グラフ上の打刻 -->
        <template>
          <vx-tooltip-with-slot-text
            v-for="timesheet in timesheetListDisp"
            :key="timesheet.key"
            position="top"
            style="position: absolute"
            :style="timesheet.style"
          >
            <!-- ホバー時に表示するツールチップ -->
            <template v-slot:text>
              <div
                class="stamping-period z-10 aisea-text-14-400-white pl-1"
                :style="timesheet.labelStyle"
              >
                <div class="time-daytime-in">
                  開始: {{ timesheet.stampingDaytimeInText }}
                </div>
                <div class="time-daytime-out">
                  終了: {{ timesheet.stampingDaytimeOutText }}
                </div>
                <div class="work">
                  <span
                    class="rect"
                    :style="{ backgroundColor: `#${timesheet.rectBgColor}` }"
                  ></span>
                  <span class="text ml-1">{{ timesheet.label }}</span>
                </div>
              </div>
            </template>
            <!-- ホバー対象 -->
            <template v-slot:inner>
              <div
                class="stamping-period z-10"
                :style="{ backgroundColor: `#${timesheet.rectBgColor}` }"
                :data-test-txt="timesheet.key"
              ></div>
            </template>
          </vx-tooltip-with-slot-text>
        </template>
        <!-- 作業グラフ上のアラート -->
        <template>
          <vx-tooltip-with-slot-text
            v-for="alert in alertListDisp"
            :key="alert.key"
            position="top"
            style="position: absolute; bottom: 0px"
            :style="alert.style"
          >
            <!-- ホバー時に表示するツールチップ -->
            <template v-slot:text>
              <div
                class="alert-period z-10 aisea-text-14-400-white pl-1"
                :style="alert.labelStyle"
              >
                <div class="alert-title">
                  {{ alert.title }}
                </div>
                <div class="work">
                  <span
                    class="rect"
                    :style="{ backgroundColor: `#${alert.rectBgColor}` }"
                  ></span>
                  <span class="text ml-1"
                    >{{ alert.label }}: {{ alert.message }}</span
                  >
                </div>
              </div>
            </template>
            <!-- ホバー対象 -->
            <template v-slot:inner>
              <div
                class="alert-period z-10"
                :style="{ backgroundColor: `#${alert.rectBgColor}` }"
                :data-test-txt="alert.key"
              ></div>
            </template>
          </vx-tooltip-with-slot-text>
        </template>
      </div>

      <!-- 1日当たりの労働時間 -->
      <div
        class="
        working-hours-per-day
        flex
        items-center
        aisea-text-16-400-gray-black
      "
      >
        {{ hourOfWorkTwentyFourHoursDisp }}
      </div>

      <!-- 時間外労働 -->
      <div class="overtime-work flex items-center aisea-text-16-400-gray-black">
        {{ dailyOvertimeDisp }}
      </div>

      <!-- 連続休息時間 -->
      <div
        class="
        working-hours-per-day
        flex
        items-center
        aisea-text-16-400-gray-black
      "
        :class="{
          alert: isHourOfRestTwentyFourHoursCritical,
        }"
      >
        {{ maxOfDividedRestTimeDisp }}
      </div>

      <!-- 過去4日間以内の労働時間 -->
      <div
        class="
        compensation-holiday-work
        flex
        items-center
        aisea-text-16-400-gray-black
      "
        :class="{
          warning: isHourOfWorkFourDaysWarning,
        }"
      >
        {{ fourDaysWorkingTimeDisp }}
      </div>

      <!-- 過去5日間以内の労働時間 -->
      <div
        class="five-days-working flex items-center aisea-text-16-400-gray-black"
        :class="{
          warning: isHourOfWorkFiveDaysWarning,
        }"
      >
        {{ fiveDaysWorkingTimeDisp }}
      </div>

      <!-- 過去6日間以内の労働時間 -->
      <div
        class="six-days-working flex items-center aisea-text-16-400-gray-black"
        :class="{
          warning: isHourOfWorkSixDaysWarning,
        }"
      >
        {{ sixDaysWorkingTimeDisp }}
      </div>

      <!-- 過去7日間以内の労働時間 -->
      <div
        class="
        working-hours-per-week
        flex
        items-center
        aisea-text-16-400-gray-black
      "
        :class="{
          alert: isHourOfWorkOneWeekCritical,
          warning: !isHourOfWorkOneWeekCritical && isHourOfWorkOneWeekWarning,
        }"
      >
        {{ hourOfWorkOneWeekDisp }}
      </div>

      <!-- 過去28日間以内の時間外労働 -->
      <div
        class="twenty-eight-days-overwork flex items-center aisea-text-16-400-gray-black"
        :class="{
          alert: isHourOfOvertimeWorkTwentyEightDaysCritical,
        }"
      >
        {{ twentyEightDaysOvertimeDisp }}
      </div>
    </template>
  </div>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import VxTooltipWithSlotText from "@/layouts/components/vx-tooltip/VxTooltipWithSlotText.vue";
import moment from "moment-timezone";

const TOOLTIP_STYLE = {
  minWidth: "114px",
};

const WARNING_HOUR = {
  color_hex: "FCCD41", // アラートで表示する色: FCCD41 / FF5252
  label: "注意", // アラートの種類 -> 今は注意・警告
  type: 0, // alertのtypeはenumになる想定
  message: "10時間以上〜14時間以内", // アラートで表示するメッセージ
  title: "24時間あたりの労働時間",
};
const CRITICAL_HOUR = {
  color_hex: "FF5252", // アラートで表示する色: FCCD41 / FF5252
  label: "警告", // アラートの種類 -> 今は注意・警告
  type: 1, // alertのtypeはenumになる想定
  message: "14時間超", // アラートで表示するメッセージ
  title: "24時間あたりの労働時間",
};
const DEFAULT_TIME_DISP = "00:00";

export default {
  name: "CrewLaborRecordRow",
  components: {
    VxTooltipWithSlotText,
  },
  mixins: [],
  props: {
    enterpriseCrewId: { type: String, require: true },
    //dateStr: { type: String, default: "" },
    roleName: { type: String, default: "" },
    // date: { type: String, default: "" },
    momentObj: { type: Object, default: () => null },
    cellSize: { type: Number, default: 30 },
    cellNum: { type: Number, default: 24 },

    dailyWorkingTime: { type: Number, default: null }, // 1日当たりの労働時間

    dailyOvertime: { type: Number, default: null }, // 時間外労働

    maxOfDividedRestTime: { type: Number, default: null }, // 連続休息時間
    isHourOfRestTwentyFourHoursCritical: { type: Boolean, default: false },

    fourDaysWorkingTime: { type: Number, default: null }, // 過去4日間以内の労働時間
    isHourOfWorkFourDaysWarning: { type: Boolean, default: false },

    fiveDaysWorkingTime: { type: Number, default: null }, // 過去5日間以内の労働時間
    isHourOfWorkFiveDaysWarning: { type: Boolean, default: false },

    sixDaysWorkingTime: { type: Number, default: null }, // 過去6日間以内の労働時間
    isHourOfWorkSixDaysWarning: { type: Boolean, default: false },

    sevenDaysWorkingTime: { type: Number, default: null }, // 過去7日間以内の労働時間
    isHourOfWorkOneWeekCritical: { type: Boolean, default: false },
    isHourOfWorkOneWeekWarning: { type: Boolean, default: false },

    twentyEightDaysOvertime: { type: Number, default: null }, // 過去28日間以内の時間外労働
    isHourOfOvertimeWorkTwentyEightDaysCritical: {
      type: Boolean,
      default: false,
    },

    tooltipStyle: { type: Object, default: () => TOOLTIP_STYLE },
    timesheetList: { type: Array, default: () => [] },
    warningHours: { type: Array, default: () => [] },
    criticalHours: { type: Array, default: () => [] },

    taskTimes: { Type: Array, default: () => [] },
    onClickRoleName: { Type: Function, default: () => {} },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    hourOfWorkTwentyFourHoursDisp() {
      if (!(typeof this.dailyWorkingTime === "number"))
        return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.dailyWorkingTime);
    },
    dailyOvertimeDisp() {
      if (!(typeof this.dailyOvertime === "number")) return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.dailyOvertime);
    },
    fourDaysWorkingTimeDisp() {
      if (!(typeof this.fourDaysWorkingTime === "number"))
        return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.fourDaysWorkingTime);
    },
    fiveDaysWorkingTimeDisp() {
      if (!(typeof this.fiveDaysWorkingTime === "number"))
        return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.fiveDaysWorkingTime);
    },
    sixDaysWorkingTimeDisp() {
      if (!(typeof this.sixDaysWorkingTime === "number"))
        return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.sixDaysWorkingTime);
    },
    hourOfWorkOneWeekDisp() {
      if (!(typeof this.sevenDaysWorkingTime === "number"))
        return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.sevenDaysWorkingTime);
    },
    twentyEightDaysOvertimeDisp() {
      if (!(typeof this.twentyEightDaysOvertime === "number"))
        return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.twentyEightDaysOvertime);
    },
    maxOfDividedRestTimeDisp() {
      if (!(typeof this.maxOfDividedRestTime === "number"))
        return DEFAULT_TIME_DISP;
      if (this.maxOfDividedRestTime < 0) return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.maxOfDividedRestTime);
    },

    taskTimesDisp() {
      if (this.taskTimes.length <= 0) return [];
      return this.taskTimes.map(taskTime => ({
        ...taskTime,
        minutes: this.getTimeFromMinutes(taskTime.minutes),
      }));
    },
    timesheetListDisp() {
      return this.timesheetList
        .map(ts => this.processTimesheet(ts))
        .filter(ts => ts !== null);
    },
    warningList() {
      if (this.warningHours.length <= 0) return [];
      return this.warningHours
        .reduce((prev, cur) => {
          if (
            prev.length === 0 ||
            cur - prev[prev.length - 1].daytime_out !== 1
          ) {
            return [
              ...prev,
              {
                daytime_in: cur,
                daytime_out: cur,
              },
            ];
          }
          prev[prev.length - 1].daytime_out = cur;
          return prev;
        }, [])
        .map(wh => ({
          daytime_in: moment(this.momentObj)
            .add(wh.daytime_in, "hours")
            .startOf("hours"),
          daytime_out: moment(this.momentObj)
            .add(wh.daytime_out, "hours")
            .endOf("hours"),
          ...WARNING_HOUR,
        }));
    },
    criticalList() {
      if (this.criticalHours.length <= 0) return [];
      return this.criticalHours
        .reduce((prev, cur) => {
          if (
            prev.length === 0 ||
            cur - prev[prev.length - 1].daytime_out !== 1
          ) {
            return [
              ...prev,
              {
                daytime_in: cur,
                daytime_out: cur,
              },
            ];
          }
          prev[prev.length - 1].daytime_out = cur;
          return prev;
        }, [])
        .map(ch => ({
          daytime_in: moment(this.momentObj)
            .add(ch.daytime_in, "hours")
            .startOf("hours")
            .format(),
          daytime_out: moment(this.momentObj)
            .add(ch.daytime_out, "hours")
            .endOf("hours")
            .format(),
          ...CRITICAL_HOUR,
        }));
    },
    alertList() {
      return [...this.warningList, ...this.criticalList];
    },
    alertListDisp() {
      return this.alertList
        .map(alert => this.processAlertList(alert))
        .filter(alert => alert !== null);
    },
    timeLineLength() {
      return this.cellSize * this.cellNum || 0;
    },
    isTimeSheetExists() {
      return this.timesheetList.length > 0;
    },
  },
  methods: {
    isPositiveNumber(num) {
      if (!(typeof num === "number")) return false;
      if (num < 0) return false;
      return true;
    },
    getTimelinePosition(momentObj) {
      if (!momentObj) return 0;
      return (moment(momentObj).hour() * 60 + moment(momentObj).minutes()) / 2;
    },
    getStampingPeriodWidth(startMomentObj, endMomentObj) {
      // 作業グラフのガントチャートっぽいところの長さを求める
      if (!startMomentObj) return 0;
      if (!endMomentObj) return 0;
      const width =
        this.getTimelinePosition(endMomentObj) -
        this.getTimelinePosition(startMomentObj);
      if (width <= 0) return 0;
      return width;
    },
    // 作業グラフ上のアラート情報を加工
    processAlertList(alert) {
      if (!alert) return {};
      const {
        color_hex: rectBgColor,
        daytime_in: daytimeIn,
        daytime_out: daytimeOut,
        title,
        label,
        message,
      } = alert;
      // 開始が終了よりも後はおかしいので弾く
      if (moment(daytimeOut).diff(moment(daytimeIn), "minutes") < 0) {
        return null;
      }
      const startOfTheDay = moment(this.momentObj).startOf("day");
      const endOfTheDay = moment(this.momentObj).endOf("day");

      // 24時間跨ぎをハンドリング
      const startMoment = moment(daytimeIn).isBefore(startOfTheDay)
        ? startOfTheDay
        : moment(daytimeIn);
      const endMoment = moment(daytimeOut).isAfter(endOfTheDay)
        ? endOfTheDay
        : moment(daytimeOut);

      const key = `alert-${label}-${daytimeIn}-${daytimeOut}`;
      const left = `${this.getTimelinePosition(startMoment)}px`;
      const width = `${this.getStampingPeriodWidth(startMoment, endMoment)}px`;

      return {
        key,
        style: {
          left,
          width,
        },
        labelStyle: {},
        title,
        label,
        message,
        rectBgColor,
      };
    },
    // 作業グラフ上の打刻情報を加工
    processTimesheet(timesheet) {
      if (!timesheet) return {};
      const {
        id: timesheetId,
        crew_task: crewTask,
        daytime_in: daytimeIn,
        daytime_out: daytimeOut,
      } = timesheet;
      const rectBgColor = crewTask.color_hex;
      // 開始が終了よりも後はおかしいので弾く
      if (moment(daytimeOut).diff(moment(daytimeIn), "minutes") < 0) {
        return null;
      }
      const startOfTheDay = moment(this.momentObj).startOf("day");
      const endOfTheDay = moment(this.momentObj).endOf("day");

      // 24時間跨ぎをハンドリング
      const startMoment = moment(daytimeIn).isBefore(startOfTheDay)
        ? startOfTheDay
        : moment(daytimeIn);
      const endMoment = moment(daytimeOut).isAfter(endOfTheDay)
        ? endOfTheDay
        : moment(daytimeOut);

      const key = `${timesheetId}-${daytimeIn}-${daytimeOut}`;
      const left = `${this.getTimelinePosition(startMoment)}px`;
      const width = `${this.getStampingPeriodWidth(startMoment, endMoment)}px`;
      const label = crewTask.is_custom
        ? crewTask.label
        : this.$t(`Views.Crew.LaborRecord.Tasks.${crewTask.label}`);

      return {
        key,
        style: {
          left,
          width,
        },
        labelStyle: {},
        stampingDaytimeInText: this.getStampingDaytimeText(moment(daytimeIn)),
        stampingDaytimeOutText: this.getStampingDaytimeText(moment(daytimeOut)),
        label,
        rectBgColor,
      };
    },
    getStampingDaytimeText(momentObj) {
      if (!momentObj) return "";
      return `${moment(momentObj).format("MM/DD HH:mm")}`;
    },
    getTimeFromMinutes(minutes) {
      if (typeof minutes !== "number") return null;
      const hours = String(Math.floor(minutes / 60)).padStart(2, 0);
      const restMinuites = String(minutes % 60).padStart(2, 0);
      return `${hours}:${restMinuites}`;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
.vessel-labor-record-row {
  flex-shrink: 0;
  height: 38px;
  border-bottom: 1px solid $aisea-light-gray;
  --alert-bg-color: #ff5252;
  --warning-bg-color: #ffd54f;
  > div {
    flex-shrink: 0;
    flex-grow: 0;
    height: 38px;
    border-radius: 0px;
    text-align: center;
    &:not(.working-graph) {
      min-width: 80px;
      width: 80px;
      padding: 4px 10px;
      &.date {
        padding: 4px 0px 4px 8px;
        min-width: 140px;
      }
      &.register-holiday {
        width: 180px;
        padding: 4px 0px 4px 4px;
      }
    }
    &:first-child {
      position: sticky;
      top: 0;
      left: 0;
    }
  }
  .date {
    background-color: $aisea-white;
    border-bottom: 1px solid $aisea-light-gray;
  }
  .the-longer-number-of-hours-when-splitting {
    width: 80px;
    padding: 0px, 20px, 0px, 10px;
  }
  .timeline {
    height: 100%;
  }
  .timeline-cell {
    height: 100%;
    min-width: 30px;
  }
  .stamping-period {
    height: 26px;
  }
  .alert-period {
    height: 6px;
  }
  .divider-div {
    .divider {
      height: 100%;
      border-left: solid 1px #e0e0e0;
      &:last-child {
        border-right: solid 1px #e0e0e0;
      }
    }
  }
  &.hover-enabled:hover {
    background-color: #e3e2e2;
    .date {
      color: #e0e0e0;
      background-color: $aisea-gray-black;
    }
    .timeline {
      background-color: #f2f2f2;
    }
  }
  .alert {
    background-color: var(--alert-bg-color);
    color: $aisea-pure-white;
  }
  .warning {
    background-color: var(--warning-bg-color);
    color: $aisea-pure-white;
  }
  .total-title-cell {
    background-color: $aisea-gray-black;
  }
  .total-cell {
    background-color: $aisea-gray;
  }
  .link-string {
    color: $aisea-blue;
    cursor: pointer;
  }
}
.vs-tooltip.with-text {
  .rect {
    border-radius: 2px;
    display: inline-block;
    width: 10px;
    height: 10px;
  }
}
</style>
